module.exports = __webpack_public_path__ + "img/like.cc47b931.svg";